'use client';
import * as React from 'react';

import { cn } from '@/lib/utils';

import H2 from '@/components/atoms/Typography/H2';
import { YouTubePlayer } from '@/components/organisms/YouTubePlayer';
import type { SectionProps } from '@/components/layout/Section';
import Section from '@/components/layout/Section';

import type { VideoSectionConfigType } from './VideoSection.types';

export interface VideoSectionProps extends SectionProps {
    config: VideoSectionConfigType;
}

const VideoSection = React.forwardRef<HTMLDivElement, VideoSectionProps>(
    (
        {
            config: { title, 'data-test-id': dataTestId, ...configProps },
            className,
            containerClassName,
            ...props
        },
        ref,
    ) => (
        <Section
            ref={ref}
            id={configProps.id || props.id}
            className={className}
            containerClassName={cn(
                'flex flex-wrap justify-center',
                containerClassName,
            )}
            {...props}
        >
            {title ? (
                <H2
                    className="mb-8 text-center"
                    data-test-id={dataTestId && `${dataTestId}-title`}
                >
                    {title}
                </H2>
            ) : null}

            <YouTubePlayer
                data-test-id={dataTestId && `${dataTestId}`}
                {...configProps}
            />
        </Section>
    ),
);

export default VideoSection;
